<template>
  <div id="header" class="">
    <span class="wallet-icon"></span>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="css" scoped>
</style>
